import simpleModal from "../libs/simpleModal";

export default function (videoUrl = '', modalHeader = '') {
    //youtu.be/{id}
    //youtube.com?v={id}
    //youtube.com/embed/{id}
    const url = new URL(videoUrl);
    let id
    if (url.hostname === 'youtube.com' || url.hostname === 'www.youtube.com') {
        if (url.searchParams.has('v')) {
            id = url.searchParams.get('v');
        } else {
            const path = url.pathname.split('/');
            if (path.length >= 3 && path[1] === 'embed') {
                id = path[2]
            }
        }
    } else if (url.hostname === 'youtu.be' || url.hostname === 'youtu.be') {
        id = url.pathname.split('/')[1]
    }
    if (!id) {
        return
    }
    const src = 'https://youtube.com/embed/' + id + '?autoplay=1&rel=0&showinfo=0&origin=' + window.location.origin
    const modal = new simpleModal({
        id: 'youtube-video',
        content: '<iframe id="ytplayer" type="text/html" width="870" height="490" frameborder="0" src="' + src + '"></iframe>',
        header: modalHeader
    })
    modal.show()
}
